<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="是否已删除 0未删除 1已删除" prop="deleted">
        <el-input v-model="form.deleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="创建人编码" prop="createUser">
        <el-input v-model="form.createUser" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker v-model="form.createTime" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="updateUser">
        <el-input v-model="form.updateUser" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="updateTime">
        <el-date-picker v-model="form.updateTime" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="会员主键" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入会员主键" v-trim/>
      </el-form-item>
      <el-form-item label="变动类型:0=用工单收入；1=货运单收入；2=供餐单收入；3=提现申请；" prop="type">
        <el-input v-model="form.type" placeholder="请输入变动类型:0=用工单收入；1=货运单收入；2=供餐单收入；3=提现申请；" v-trim/>
      </el-form-item>
      <el-form-item label="收支类型:1=收入；-1=支出；" prop="optType">
        <el-input v-model="form.optType" placeholder="请输入收支类型:1=收入；-1=支出；" v-trim/>
      </el-form-item>
      <el-form-item label="变动金额" prop="amount">
        <el-input v-model="form.amount" placeholder="请输入变动金额" v-trim/>
      </el-form-item>
      <el-form-item label="变动前金额" prop="beforeAmount">
        <el-input v-model="form.beforeAmount" placeholder="请输入变动前金额" v-trim/>
      </el-form-item>
      <el-form-item label="变动后金额" prop="afterAmount">
        <el-input v-model="form.afterAmount" placeholder="请输入变动后金额" v-trim/>
      </el-form-item>
      <el-form-item label="业务记录主键" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入业务记录主键" v-trim/>
      </el-form-item>
      <el-form-item label="业务类型:0=订单业务；1=提现业务；" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入业务类型:0=订单业务；1=提现业务；" v-trim/>
      </el-form-item>
      <el-form-item label="业务状态:0=成功；1=失败；2=处理中；" prop="status">
        <el-input v-model="form.status" placeholder="请输入业务状态:0=成功；1=失败；2=处理中；" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaMemberRevenueWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        deleted: '',
        createUser: '',
        createTime: '',
        updateUser: '',
        updateTime: '',
        remark: '',
        memberId: '',
        type: '',
        optType: '',
        amount: '',
        beforeAmount: '',
        afterAmount: '',
        objId: '',
        objType: '',
        status: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/memberRevenue',
      'field.id': 'id'
    })
  }
}
</script>
